const brightness = {
    name: "brightness",
    path: "/brightness",
    title: "brightness",
    description: "Utilities for applying brightness filter effects to elements.",
    value: {
        'filter': {
            'brightness-<number>': 'brightness(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "brightness-50, brightness-100",
            "description": "to control an element's brightness:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg brightness-50",
                        "text": "brightness-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg brightness-100",
                        "text": "brightness-100",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg brightness-125",
                        "text": "brightness-125",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg brightness-200",
                        "text": "brightness-200",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="brightness-50" src="/img/mountains.jpg" />
<img class="brightness-100" src="/img/mountains.jpg" />
<img class="brightness-125" src="/img/mountains.jpg" />
<img class="brightness-200" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default brightness;